export const aspects = [
    {
        name: 'Aggression',
        img: 'images/aspects/MC01en_55.jpg',
        packs: [
            "Core Set",
            "Thor",
            "Hulk",
            "The Rise of Red Skull",
            "Wasp",
            "Galaxy's Most Wanted",
            "Gamora",
            "The Mad Titan's Shadow",
            "Valkyrie",
            "Nova",
            "Mutant Genesis",
            "Wolverine",
            "X-23",
            "Age of Apocalypse",
            "Iceman",
            "Winter Soldier",
            "Civil War"
        ]
    },
    {
        name: 'Justice',
        img: 'images/aspects/MC01en_62.jpg',
        packs: [
            "Core Set",
            "Black widow",
            "The Rise of Red Skull",
            "Scarlet Witch",
            "Venom",
            "The Mad Titan's Shadow",
            "Nebula",
            "Sinister Motives",
            "Spider-Ham",
            "Phoenix",
            "Gambit",
            "NeXt Evolution",
            "Psylocke",
            "Jubilee",
            "Agents of S.H.I.E.L.D.",
            "Black Panther",
            "Wonder Man"

        ]
    },
    {
        name: 'Leadership',
        img: 'images/aspects/MC01en_72.jpg',
        packs: [
            "Core Set",
            "Captain America",
            "The Rise of Red Skull",
            "Ant-Man",
            "Star-Lord",
            "The Mad Titan's Shadow",
            "War Machine",
            "Ironheart",
            "Cyclops",
            "Storm",
            "NeXt Evolution",
            "Age of Apocalypse",
            "Magneto",
            "Falcon",
            "Hercules"
        ]
    },
    {
        name: 'Protection',
        img: 'images/aspects/MC01en_79.jpg',
        packs: [
            "Core Set",
            "Ms. Marvel",
            "Doctor Strange",
            "Quicksilver",
            "Galaxy's Most Wanted",
            "Drax",
            "The Mad Titan's Shadow",
            "Vision",
            "Sinister Motives",
            "SP//dr",
            "Mutant Genesis",
            "Rogue",
            "Angel",
            "Nightcrawler",
            "Silk",
            "Civil War"
        ]
    },
    {
        name: '\'Pool',
        img: 'images/aspects/mc44_announce_cards_igotthis.png',
        packs: ["Deadpool"]
    }
];
